<template>
  <div class="sp-table-footer" part="pager">
    <TablePerPageSelect
      v-if="offersPerPageChoice"
      :per-page="perPage"
      :options="perPageChoices"
      @change="onPerPageChange"
    />

    <TablePageNumbers
      v-if="variant === 'pages'"
      :page="page"
      :page-count="pageCount"
      :is-first-page="isFirstPage"
      :is-last-page="isLastPage"
      @change="onPageChange"
    />
    <TablePageNavigation
      v-else
      :page="page"
      :page-count="pageCount"
      :is-first-page="isFirstPage"
      :is-last-page="isLastPage"
      @change="onPageChange"
    />
  </div>
</template>

<script setup>
import { computed } from "vue";

import TablePageNavigation from "./TablePageNavigation.ce.vue";
import TablePageNumbers from "./TablePageNumbers.ce.vue";
import TablePerPageSelect from "./TablePerPageSelect.ce.vue";

const props = defineProps({
  /**
   * Which pager to render: "steps" for a page count with Previous and Next, "pages" for numbered
   * pages with First and Last.
   */
  variant: {
    type: String,
    default: "steps",
  },
  page: {
    type: Number,
    default: 1,
  },
  pageCount: {
    type: Number,
    default: 1,
  },
  perPage: {
    type: Number,
    default: undefined,
  },
  /**
   * Page sizes the picker offers, which always include the current one.
   */
  perPageChoices: {
    type: Array,
    default: () => [],
  },
  isFirstPage: {
    type: Boolean,
    default: false,
  },
  isLastPage: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["page-change"]);

// A picker offering only the current size is a control with nothing to choose.
const offersPerPageChoice = computed(() => props.perPageChoices.length > 1);

function onPageChange(page) {
  emit("page-change", { page, perPage: props.perPage });
}

// Changing the page size renumbers every page, so the reader goes back to the first.
function onPerPageChange(perPage) {
  emit("page-change", { page: 1, perPage });
}
</script>

<style lang="scss" scoped>
.sp-table-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: var(--sp-comp-table-pager-gap, var(--sp-ref-scale-12));
  padding: var(--sp-comp-table-pager-padding, var(--sp-ref-scale-4) var(--sp-ref-scale-6));
  color: var(--table-header-color);
  font-size: var(--sp-comp-table-font-size, var(--sp-ref-font-size-small));
}
</style>
